import { c as _c } from "react/compiler-runtime";
import { useQueries, useQueryClient } from '@tanstack/react-query';
import type { FormattedAddress } from '../../../../../onboarding-business-insight.types';
import GoogleMapsLoader from './google-maps-loader';
type Coordinates = {
  latitude: number | undefined;
  longitude: number | undefined;
};
const getCoordinatesFromAddress = async (addressStr: string): Promise<Coordinates | undefined> => {
  try {
    await GoogleMapsLoader.importLibrary('geocoding');
    const geocoder = new google.maps.Geocoder();
    const result = await geocoder.geocode({
      address: addressStr
    });
    return {
      latitude: result.results[0].geometry.location.lat(),
      longitude: result.results[0].geometry.location.lng()
    };
  } catch (_e) {
    return undefined;
  }
};
const useAddressCoordinates = data => {
  const $ = _c(14);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== data || $[1] !== queryClient) {
    let t1;
    if ($[3] !== queryClient) {
      t1 = address => ({
        queryKey: ["onboardings", "offices", address.id],
        queryFn: async () => {
          if (address.latitude && address.longitude) {
            return address;
          }
          const cachedCoordinates = queryClient.getQueryData(["business-insights", address.id]);
          if (cachedCoordinates) {
            return {
              ...address,
              ...cachedCoordinates
            };
          }
          const addressFields = [address.addressLine1, address.city, address.state, address.postalCode];
          if (addressFields.every(Boolean)) {
            const completeAddress = addressFields.join(", ");
            const coordinates = await getCoordinatesFromAddress(completeAddress);
            return {
              ...address,
              ...coordinates
            };
          }
          return address;
        }
      });
      $[3] = queryClient;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = data.map(t1);
    $[0] = data;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[5] !== t0) {
    t1 = {
      queries: t0
    };
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const queries = useQueries(t1);
  let t2;
  if ($[7] !== queries) {
    t2 = queries.map(_temp).filter(_temp2);
    $[7] = queries;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = t2 as FormattedAddress[];
  let t4;
  if ($[9] !== queries) {
    t4 = queries.some(_temp3);
    $[9] = queries;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      data: t3,
      isPending: t4
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default useAddressCoordinates;
function _temp(query) {
  return query.data;
}
function _temp2(data_0) {
  return data_0?.latitude && data_0?.longitude;
}
function _temp3(query_0) {
  return query_0.isLoading;
}